var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "hosted-invoice-page", style: _vm.canvasStyle },
    [
      !_vm.invoice || !_vm.account
        ? _c(
            "div",
            { staticClass: "invoice-loading", attrs: { role: "status" } },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: 36,
                  width: 3,
                  color: "primary"
                }
              })
            ],
            1
          )
        : _c("div", { staticClass: "hosted-invoice-shell" }, [
            _c(
              "header",
              { staticClass: "hosted-invoice-toolbar d-print-none" },
              [
                _c("div", { staticClass: "invoice-identity" }, [
                  _c(
                    "span",
                    {
                      staticClass: "invoice-mark",
                      attrs: { "aria-hidden": "true" }
                    },
                    [
                      _c("portal-icon", {
                        attrs: { name: "receipt-text", size: 20 }
                      })
                    ],
                    1
                  ),
                  _c("div", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("invoices.list.invoice-number")))
                    ]),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.invoice.invoiceNumberFormatted))
                    ])
                  ])
                ]),
                _c("div", { staticClass: "viewer-actions" }, [
                  _vm.rendererType === "InvoiceRenderer"
                    ? _c(
                        "div",
                        { staticClass: "language-control" },
                        [_c("language-switcher")],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "download-action",
                      attrs: { type: "button" },
                      on: { click: _vm.downloadPdf }
                    },
                    [
                      _c("portal-icon", {
                        attrs: { name: "download", size: 18 }
                      }),
                      _c("span", [_vm._v("Download PDF")])
                    ],
                    1
                  )
                ])
              ]
            ),
            _c(
              "section",
              { staticClass: "hosted-document-surface" },
              [
                _c(_vm.rendererType, {
                  key: _vm.refreshKey,
                  tag: "component",
                  staticClass: "hosted-invoice-document",
                  attrs: {
                    invoice: _vm.invoice,
                    "scheduled-payments": _vm.invoice.scheduledPayments,
                    account: _vm.account,
                    "edit-mode": false,
                    "attachment-service": _vm.invoiceService,
                    "invoice-service": _vm.invoiceService,
                    appearance: _vm.effectiveAppearance
                  },
                  on: { "pay-now": _vm.goToPaymentPage }
                })
              ],
              1
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }